import React from 'react';
import { Container } from '../components/ui/Container';
import { Button } from '../components/ui/Button';
import { Target, Users, Zap } from 'lucide-react';
export function AboutPage() {
  return <div className="bg-white" data-id="element-353">
      {/* Hero */}
      <div className="bg-gray-900 py-20 lg:py-32 text-center text-white" data-id="element-354">
        <Container data-id="element-355">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl mb-6" data-id="element-356">
            About Flowsense
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-357">
            We're on a mission to help every brand unlock the full potential of
            their email marketing flows.
          </p>
        </Container>
      </div>

      {/* Our Story */}
      <section className="py-24" data-id="element-358">
        <Container data-id="element-359">
          <div className="max-w-3xl mx-auto" data-id="element-360">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 mb-6" data-id="element-361">
              Our Story
            </h2>
            <div className="prose prose-lg text-gray-600" data-id="element-362">
              <p className="mb-4" data-id="element-363">
                Flowsense was founded in 2025 by the founder who spent years
                optimizing email flows for e-commerce brands. After analyzing
                thousands of flows, they noticed a pattern: most brands were
                leaving significant revenue on the table due to simple, fixable
                issues in their automation.
              </p>
              <p className="mb-4" data-id="element-364">
                The problem wasn't lack of effort—it was lack of visibility.
                Brands didn't know which flows were underperforming or what
                specific changes would drive the biggest impact. Manual audits
                were time-consuming and inconsistent.
              </p>
              <p data-id="element-365">
                That's why we built Flowsense: to give every marketer AI-powered
                insights that used to require hiring expensive consultants. Now,
                anyone can optimize their flows with confidence and prove the
                ROI of their work.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Values */}
      <section className="py-24 bg-gray-50" data-id="element-366">
        <Container data-id="element-367">
          <div className="text-center mb-16" data-id="element-368">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900" data-id="element-369">
              Our Values
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-370">
            {[{
            icon: Target,
            title: 'Impact-Driven',
            desc: 'Every feature we build is designed to drive measurable revenue impact for our customers.'
          }, {
            icon: Users,
            title: 'Customer-First',
            desc: 'We listen to our users and iterate quickly based on their feedback and needs.'
          }, {
            icon: Zap,
            title: 'Innovation',
            desc: 'We leverage cutting-edge AI to solve real marketing problems in novel ways.'
          }].map((value, i) => <div key={i} className="text-center" data-id="element-371">
                <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 mb-6" data-id="element-372">
                  <value.icon className="h-8 w-8 text-white" data-id="element-373" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-374">
                  {value.title}
                </h3>
                <p className="text-gray-600" data-id="element-375">{value.desc}</p>
              </div>)}
          </div>
        </Container>
      </section>

      {/* Team */}
      <section className="py-24" data-id="element-376">
        <Container data-id="element-377">
          <div className="text-center mb-16" data-id="element-378">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900" data-id="element-379">
              Meet the Team
            </h2>
          </div>
          <div className="flex justify-center" data-id="element-380">
            <div className="text-center max-w-sm" data-id="element-381">
              <img src="https://cdn.magicpatterns.com/uploads/m1RrFSkWrx1tCaoExUYDNQ/diran-1000.webp" alt="Diran George" className="mx-auto h-48 w-48 rounded-full object-cover object-top mb-6" data-id="element-382" />
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-383">
                Diran George
              </h3>
              <p className="text-primary font-medium mb-4" data-id="element-384">Founder</p>
              <p className="text-gray-600" data-id="element-385">
                Digital Marketer and Technologist with 20 years marketing
                technology experience.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Company Info */}
      <section className="py-24 bg-gray-900" data-id="element-386">
        <Container data-id="element-387">
          <div className="text-center max-w-3xl mx-auto" data-id="element-388">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6" data-id="element-389">
              Join Us on Our Mission
            </h2>
            <p className="text-xl text-gray-300 mb-10" data-id="element-390">
              Flowsense is built by Acciom Limited, dedicated to helping brands
              maximize their email marketing ROI.
            </p>
            <a href="https://go.useflowsense.com/signup" data-id="element-391">
              <Button size="lg" data-id="element-392">Get Started</Button>
            </a>
          </div>
        </Container>
      </section>
    </div>;
}